module.exports = __webpack_public_path__ + "img/banner-header_00-nosotros.f8558793.png";